import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listServices, setServiceActive, deleteService } from './adminApi';

const TYPE_LABEL = {
    WEEKLY: 'Еженедельно',
    N_DAYS_FORWARD: 'N дней вперёд',
    DATE_RANGES: 'Диапазоны дат',
};

export default function ServicesList() {
    const [services, setServices] = useState(null);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const load = () => {
        listServices().then(setServices).catch((e) => setError(e.message));
    };
    useEffect(load, []);

    const toggle = async (s) => {
        try {
            await setServiceActive(s.id, !s.is_active);
            load();
        } catch (e) { setError(e.message); }
    };

    const remove = async (s) => {
        if (!window.confirm(`Удалить сервис «${s.name}»? Все его записи будут удалены.`)) return;
        try {
            await deleteService(s.id);
            load();
        } catch (e) { setError(e.message); }
    };

    if (error) return <div className="a-error">{error}</div>;
    if (!services) return <div className="a-muted">Загрузка…</div>;

    return (
        <div>
            <div className="a-page-head">
                <h1>Сервисы</h1>
                <button className="a-btn a-btn-primary" onClick={() => navigate('/admin/services/new')}>
                    + Новый сервис
                </button>
            </div>

            {services.length === 0 && <div className="a-empty">Пока нет ни одного сервиса. Создайте первый.</div>}

            <div className="a-cards">
                {services.map((s) => (
                    <div className={`a-card ${s.is_active ? '' : 'a-card-off'}`} key={s.id}>
                        <div className="a-card-main">
                            <div className="a-card-title">{s.name}</div>
                            <div className="a-card-meta">
                                <span className="a-tag">{TYPE_LABEL[s.service_type] || s.service_type}</span>
                                <span className="a-tag">{s.bookings_count} записей</span>
                                {s.club_selection_enabled && <span className="a-tag">выбор клуба</span>}
                                {!s.is_active && <span className="a-tag a-tag-off">выключен</span>}
                            </div>
                        </div>
                        <div className="a-card-actions">
                            <label className="a-switch" title="Активность">
                                <input type="checkbox" checked={s.is_active} onChange={() => toggle(s)} />
                                <span className="a-slider" />
                            </label>
                            <button className="a-btn" onClick={() => navigate(`/admin/services/${s.id}/bookings`)}>Записи</button>
                            <button className="a-btn" onClick={() => navigate(`/admin/services/${s.id}`)}>Изменить</button>
                            <button className="a-btn a-btn-danger" onClick={() => remove(s)}>Удалить</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
